/* eslint-disable func-names */
<template>
    <div class="hosted-layers-wrap">
        <UploadHeader colorClass="white" />
        <div class="slds-p-around_x-large">
            <article class="slds-card">
                <div class="slds-card__header slds-grid">
                    <header class="slds-media slds-media_center slds-has-flexi-truncate">
                        <div class="slds-media__body">
                            <h2 class="slds-card__header-title slds-text-heading_medium">
                                <span>Data Sources</span>
                            </h2>
                        </div>
                        <div v-if="store__isLoading === true">
                            <MASpinner
                                theme="brand"
                                size="large"
                            />
                        </div>
                        <div
                            v-else
                            class="slds-form-element__control slds-input-has-icon slds-input-has-icon_left-right"
                            style="min-width: 250px;"
                        >
                            <MAIcon
                                src="~icons/utility/search.svg"
                                :iconClass="['slds-icon', 'slds-input__icon', 'slds-input__icon_left', 'slds-icon-text-default']"
                            />
                            <input
                                id="text-input-id-1"
                                v-model="filterTerm"
                                type="text"
                                :placeholder="`Search Your Data Sources...`"
                                class="slds-input"
                            >
                            <button
                                class="slds-button slds-button_icon slds-input__icon slds-input__icon_right"
                                title="Clear"
                                @click="filterTerm = null"
                            >
                                <MAIcon
                                    src="~icons/utility/clear.svg"
                                    :iconClass="['slds-button__icon', 'slds-icon-text-light']"
                                />
                                <span class="slds-assistive-text">Clear</span>
                            </button>
                        </div>
                        <button
                            class="slds-button slds-button_brand slds-m-left--large"
                            @click="store__toggleCreateModal()"
                        >
                            <span class="ma-icon ma-icon-add"></span>
                            New
                        </button>
                    </header>
                </div>
                <div class="slds-card__body">
                    <div
                        v-if="tableEmpty"
                        class="table-empty-state slds-grid slds-grid slds-grid_vertical-align-center slds-grid_align-center slds-p-around_large slds-grid_vertical"
                    >
                        <figure>
                            <img src="@/assets/empty-state-assistant.svg">
                        </figure>
                        <div class="slds-p-vertical_small slds-text-align_center">
                            <h4 class="slds-text-heading_medium">
                                No Custom Data Sets
                            </h4>
                            <p class="slds-text-body_regular slds-grid slds-grid_vertical-align-center">
                                <span>Click the + New Button above to get started uploading your data</span>
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <table
                            class="slds-table slds-table_bordered slds-table_fixed-layout slds-table_resizable-cols"
                            role="grid"
                        >
                            <thead>
                                <tr class="slds-line-height_reset">
                                    <th
                                        aria-label="Name"
                                        aria-sort="none"
                                        class="slds-text-title_caps slds-is-sortable"
                                        scope="col"
                                    >
                                        <a
                                            class="slds-th__action slds-text-link_reset"
                                            href="javascript:void(0);"
                                            role="button"
                                            tabindex="-1"
                                        >
                                            <span class="slds-assistive-text">Sort by: </span>
                                            <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                                                <span
                                                    class="slds-truncate"
                                                    title="Name"
                                                >Name</span>
                                                <span
                                                    v-if="(nameSort)"
                                                    class="slds-icon_container slds-icon-utility-arrowdown"
                                                    @click="sortBy('datasetLabel', true)"
                                                >
                                                    <span class="ma-icon ma-icon-arrowdown slds-is-sortable__icon"></span>
                                                </span>
                                                <span
                                                    v-else
                                                    class="slds-icon_container slds-icon-utility-arrowdown"
                                                    @click="sortBy('datasetLabel', false)"
                                                >
                                                    <span class="ma-icon ma-icon-arrowup slds-is-sortable__icon"></span>
                                                </span>
                                            </div>
                                        </a>
                                    </th>
                                    <th
                                        aria-label="Description"
                                        aria-sort="none"
                                        class="slds-text-title_caps descriptionHeader"
                                        scope="col"
                                    >
                                        <div class="slds-grid slds-grid_vertical-align-left slds-has-flexi-truncate">
                                            <span
                                                class="slds-truncate"
                                                title="Description"
                                            >Description</span>
                                        </div>
                                    </th>
                                    <th
                                        aria-label="Status"
                                        aria-sort="none"
                                        class="slds-text-title_caps slds-is-sortable"
                                        scope="col"
                                    >
                                        <a
                                            class="slds-th__action slds-text-link_reset"
                                            href="javascript:void(0);"
                                            role="button"
                                            tabindex="-1"
                                        >
                                            <span class="slds-assistive-text">Sort by: </span>
                                            <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                                                <span
                                                    class="slds-truncate"
                                                    title="Status"
                                                >Status</span>
                                                <span
                                                    v-if="(statusSort)"
                                                    class="slds-icon_container slds-icon-utility-arrowdown"
                                                    @click="sortBy('status', true)"
                                                >
                                                    <span class="ma-icon ma-icon-arrowdown slds-is-sortable__icon"></span>
                                                </span>
                                                <span
                                                    v-else
                                                    class="slds-icon_container slds-icon-utility-arrowdown"
                                                    @click="sortBy('status', false)"
                                                >
                                                    <span class="ma-icon ma-icon-arrowup slds-is-sortable__icon"></span>
                                                </span>
                                            </div>
                                        </a>
                                    </th>
                                    <th
                                        aria-label="Date Created"
                                        aria-sort="none"
                                        class="slds-text-title_caps slds-is-sortable"
                                        scope="col"
                                    >
                                        <a
                                            class="slds-th__action slds-text-link_reset"
                                            href="javascript:void(0);"
                                            role="button"
                                            tabindex="-1"
                                        >
                                            <span class="slds-assistive-text">Sort by: </span>
                                            <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                                                <span
                                                    class="slds-truncate"
                                                    title="Date Created"
                                                >Date Created</span>
                                                <span
                                                    v-if="(dateSort)"
                                                    class="slds-icon_container slds-icon-utility-arrowdown"
                                                    @click="sortBy('creationDate', true)"
                                                >
                                                    <span class="ma-icon ma-icon-arrowdown slds-is-sortable__icon"></span>
                                                </span>
                                                <span
                                                    v-else
                                                    class="slds-icon_container slds-icon-utility-arrowdown"
                                                    @click="sortBy('creationDate', false)"
                                                >
                                                    <span class="ma-icon ma-icon-arrowup slds-is-sortable__icon"></span>
                                                </span>
                                            </div>
                                        </a>
                                    </th>
                                    <th
                                        class="slds-text-title_caps"
                                        scope="col"
                                        style="width: 3.25rem;"
                                    >
                                        <div class="slds-truncate slds-assistive-text">
                                            Actions
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(dataset, index) in filteredDS"
                                    :key="index"
                                    aria-selected="false"
                                    :class="{ 'ma-selected-row': (isNew && isNew === dataset.datasetID) }"
                                    class="slds-hint-parent"
                                >
                                    <th
                                        scope="row"
                                        tabindex="0"
                                    >
                                        <div
                                            class="slds-truncate"
                                            title="Dataset Name"
                                        >
                                            {{ dataset.datasetLabel }}
                                        </div>
                                    </th>
                                    <td role="gridcell">
                                        <div class="datasetDesc">
                                            <div
                                                class="slds-truncate"
                                                title="Description"
                                                :aria-describedby="dataset.datasetID"
                                            >
                                                {{ dataset.datasetDescription }}
                                            </div>
                                            <div
                                                :id="dataset.datasetID"
                                                class="slds-popover slds-popover_tooltip slds-slide-from-right-to-left"
                                                role="tooltip"
                                                style="position:absolute;top:-4px;left:35px"
                                            >
                                                <div class="slds-popover__body">
                                                    {{ dataset.datasetDescription }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td role="gridcell">
                                        <span
                                            class="slds-pill_link"
                                            title="Dataset Status"
                                            :class="{ 'slds-pill': translateStatus(dataset.status).translation === 'Processing'}"
                                        >
                                            <span
                                                v-if="translateStatus(dataset.status)=== 'Processing'"
                                                class="slds-pill__icon_container"
                                            >
                                                <span class="slds-icon_container">
                                                    <div
                                                        role="status"
                                                        class="slds-spinner slds-spinner_xx-small"
                                                    >
                                                        <span class="slds-assistive-text">Loading</span>
                                                        <div class="slds-spinner__dot-a"></div>
                                                        <div class="slds-spinner__dot-b"></div>
                                                    </div>
                                                </span>
                                            </span>
                                            <span class="slds-pill__action">
                                                <span class="slds-pill__label">{{ translateStatus(dataset.status).translation }}</span>
                                                <span
                                                    v-if="translateStatus(dataset.status).translation === 'Failed'"
                                                    class="ma-icon ma-icon-warning slds-m-left_x-small"
                                                ></span>
                                            </span>
                                        </span>
                                    </td>
                                    <td role="gridcell">
                                        <div
                                            class="slds-truncate"
                                            title="Creation Date"
                                        >
                                            {{ moment(dataset.creationDate).format('MMMM D, YYYY') }}
                                        </div>
                                    </td>
                                    <td role="gridcell">
                                        <MAActionMenu forceRight>
                                            <button
                                                slot="button"
                                                class="slds-button slds-button_icon slds-button_icon-border-filled slds-button_icon-x-small"
                                            >
                                                <span class="slds-button__icon ma-icon ma-icon-down"></span>
                                            </button>

                                            <MAActionMenuItem
                                                label="View"
                                                @click="viewSchema(dataset)"
                                            />
                                            <MAActionMenuItem
                                                v-if="dataset.status === 'UPLOAD_COMPLETE'"
                                                label="Edit"
                                                @click="editDatasetDescription(dataset)"
                                            />
                                            <MAActionMenuItem
                                                label="Delete"
                                                @click="deleteDataSet(dataset)"
                                            />
                                        </MAActionMenu>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </article>
        </div>

        <CreateSchemaModal v-if="store__showCreateModal" />
        <ReadOnlySchemaModal v-if="store__showReadOnlyModal" />
        <EditDescriptionModal v-if="store__showEditModal" />
        <DeleteConfirmationModal v-if="store__showDeleteModal" />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import moment from 'moment';

import MAActionMenu from '@mapanything/ma-lib/src/vue/components/MAActionMenu.vue';
import MAActionMenuItem from '@mapanything/ma-lib/src/vue/components/MAActionMenuItem.vue';
import MASpinner from '@mapanything/ma-lib/src/vue/components/MASpinner.vue';
import CreateSchemaModal from './CreateSchemaModal.vue';
import ReadOnlySchemaModal from './ReadOnlySchemaModal.vue';
import EditDescriptionModal from './EditDescriptionModal.vue';
import DeleteConfirmationModal from './DeleteConfirmationModal.vue';
import UploadHeader from './UploadHeader';

export default {
    name: 'Dashboard',
    components: {
        MAActionMenu,
        MAActionMenuItem,
        CreateSchemaModal,
        ReadOnlySchemaModal,
        EditDescriptionModal,
        DeleteConfirmationModal,
        UploadHeader,
        MASpinner
    },
    data() {
        return {
            moment,
            descriptionComplete: false,
            schemaConfigComplete: false,
            datasets: [],
            tableEmpty: false,
            nameSort: false,
            statusSort: false,
            orgIdSort: false,
            dateSort: false,
            isNew: null,
            filterTerm: '',
            timeout: null
        };
    },
    computed: {
        ...mapState({
            store__loginState: 'loginState',
            store__dataset: 'dataset',
            store__spatialReferencePickerVisible: 'spatialReferencePickerVisible',
            store__spatialReferenceSelectionDone: 'spatialReferenceSelectionDone',
            store__spatialValuesIndex: 'spatialValuesIndex',
            store__isLoading: 'isLoading',
            store__showCreateModal: 'showCreateModal',
            store__showReadOnlyModal: 'showReadOnlyModal',
            store__showEditModal: 'showEditModal',
            store__showDeleteModal: 'showDeleteModal',
            store__datasetToEdit: 'datasetToEdit',
            store__datasetReadOnly: 'datasetReadOnly'
        }),
        filteredDS() {
            if (!this.filterTerm) return this.datasets;
            const ft = this.filterTerm.toLowerCase();
            const fds = this.datasets.filter((ds) => (ds.datasetLabel.toLowerCase().indexOf(ft) !== -1 || ds.datasetDescription.toLowerCase().indexOf(ft) !== -1 || this.translateStatus(ds.status).translation.toLowerCase().indexOf(ft) !== -1));
            return fds;
        }
    },
    watch: {
        store__showCreateModal(val) {
            if (!val) this.refreshDashboard();
        },
        store__showEditModal(val) {
            if (!val) this.refreshDashboard();
        },
        store__showDeleteModal(val) {
            if (!val) this.refreshDashboard();
        }
    },
    mounted() {
        // Login procedure will return the creator
        if (this.store__loginState.userId) {
            this.store__toggleSpinner(true);
            this.refreshDashboard();
            setInterval(this.checkForUpdates, 10000);
        }
    },
    methods: {
        ...mapMutations({
            store__toggleCreateModal: 'toggleCreateModal',
            store__toggleReadOnlyModal: 'toggleReadOnlyModal',
            store__toggleEditModal: 'toggleEditModal',
            store__toggleDeleteModal: 'toggleDeleteModal',
            store__toggleSpinner: 'toggleSpinner'
        }),
        /* Sorts datasets by specified property and direction */
        sortBy(property, ascending) {
            if (property === 'datasetLabel') this.nameSort = !this.nameSort;
            if (property === 'orgIDs') this.orgIdSort = !this.orgIdSort;
            if (property === 'status') this.statusSort = !this.statusSort;
            if (property === 'creationDate') this.dateSort = !this.dateSort;

            this.datasets.sort((a, b) => {
                a = a[property];
                b = b[property];

                if (property === 'orgIDs') {
                    a = a.join(',');
                    b = b.join(',');
                }

                if (property === 'status') {
                    a = this.translateStatus(a).translation;
                    b = this.translateStatus(b).translation;
                }

                // Change everything in the name column to a lowercase string for better sorting
                if (property === 'datasetLabel') {
                    a = a.toString().toLowerCase();
                    b = b.toString().toLowerCase();
                }

                // Sort ascending
                if (ascending) {
                    if (a < b) {
                        return -1;
                    }
                    if (a > b) {
                        return 1;
                    }
                    return 0;
                }
                // Sort descending
                if (a > b) {
                    return -1;
                }
                if (a < b) {
                    return 1;
                }
                return 0;
            });
        },
        /* Gets all datasets created by this user */
        getDatasets() {
            return new Promise((resolve, reject) => {
                const API_URL = document.location.href;

                this.$http.get(`${API_URL}api/dataset`)
                .then((res) => {
                    if (res.status === 200) {
                        resolve(res);
                    } else {
                        reject(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        /* Renames name of status */
        translateStatus(status) {
            const uploadStates = {
                UPLOAD_COMPLETE: {
                    translation: 'Active',
                    icon: 'ma-icon-check'
                },
                GEOCODING_REQUIRED: {
                    translation: 'Processing',
                    icon: 'ma-icon-spinner'
                },
                GEOCODING_COMPLETE: {
                    translation: 'Processing',
                    icon: 'ma-icon-spinner'
                },
                GEOCODING_FAILED: {
                    translation: 'Failed',
                    icon: 'ma-icon-warning'
                },
                UPLOAD_FAILED: {
                    translation: 'Failed',
                    icon: 'ma-icon-warning'
                },
                UPLOAD_IN_PROGRESS: {
                    translation: 'Processing',
                    icon: 'ma-icon-spinner'
                },
                GEOCODING_IN_PROGRESS: {
                    translation: 'Processing',
                    icon: 'ma-icon-spinner'
                },
                UNKNOWN: {
                    translation: 'Failed',
                    icon: 'ma-icon-warning'
                }
            };

            return uploadStates[status];
        },
        /* Refreshes Dashboard Content */
        refreshDashboard() {
            this.getDatasets()
            .then((res) => {
                // Identify if there is a new dataset to highlight yellow after upload success.
                this.highlightAnyNewDataset(res.data);

                // Clear datasets array first...
                this.datasets = [];

                // Then repopulate it to show the latest...
                res.data.forEach((dataset) => {
                    this.datasets.push(dataset);
                });
                // Sort by latest date. (Look into making this whatever the user last toggled for sorting)
                this.sortBy('creationDate', false);

                // Remove anti-state if we have datasets.
                if (this.datasets.length > 0) {
                    this.tableEmpty = false;
                } else {
                    this.tableEmpty = true;
                }
            })
            .catch((err) => {
                throw err;
            })
            .finally(() => this.store__toggleSpinner(false));
        },
        /* Compares current dataset array with recently retrieved one and adds a highlighting class to it */
        highlightAnyNewDataset(newDatasets) {
            newDatasets = newDatasets.map((dataset) => dataset.datasetID);
            const currentDatasets = this.datasets.map((dataset) => dataset.datasetID);

            if (currentDatasets.length > 0) {
                if (newDatasets.length > currentDatasets.length) {
                    const differenceInArrays = newDatasets.filter((d) => !currentDatasets.includes(d))[0];
                    // Highlight new row...
                    this.isNew = differenceInArrays;
                    // Remove highlight after 5 seconds...
                    setTimeout(() => {
                        this.isNew = null;
                    }, 5000);
                }
            }
        },
        /* Checks if we need to refresh while a dataset is in progress */
        checkForUpdates() {
            const currentDatasetStatuses = this.datasets.map((dataset) => dataset.status);
            if (currentDatasetStatuses.length >= 1) {
                if (currentDatasetStatuses.includes('GEOCODING_REQUIRED')
                    || currentDatasetStatuses.includes('GEOCODING_COMPLETE')
                    || currentDatasetStatuses.includes('UPLOAD_IN_PROGRESS')
                    || currentDatasetStatuses.includes('GEOCODING_IN_PROGRESS')) {
                    this.refreshDashboard();
                }
            }
        },
        /* Prompts user to confirm deletion of dataset */
        deleteDataSet(dataset) {
            this.store__datasetToEdit.datasetLabel = dataset.datasetLabel;
            this.store__datasetToEdit.datasetID = dataset.datasetID;
            this.store__toggleDeleteModal();
        },
        /* Opens modal that allows to edit the name, description, and orgID access for a dataset */
        editDatasetDescription(dataset) {
            this.store__datasetToEdit.datasetLabel = dataset.datasetLabel;
            this.store__datasetToEdit.datasetDescription = dataset.datasetDescription;
            this.store__datasetToEdit.organizationIds = dataset.orgIDs.join(', ');
            this.store__datasetToEdit.datasetID = dataset.datasetID;
            this.store__toggleEditModal();
        },
        /* Opens modal with read-only view of schema */
        viewSchema(dataset) {
            this.store__datasetReadOnly.datasetLabel = dataset.datasetLabel;
            this.store__datasetReadOnly.columnFormat = dataset.columnFormat;
            this.store__toggleReadOnlyModal();
        }
    }
};
</script>

<style lang="scss">
@import 'node_modules/@salesforce-ux/design-system/scss/_design-tokens';
    .slds-popover_tooltip {
        display: none;
        position: absolute;
        visibility: visible;
        opacity: 1;
        overflow: visible;
        cursor: default;
        z-index: 9999;

        .slds-popover__body {
            white-space: normal;
            padding: .75rem;
        }
    }
    .slds-global-header_container{
        position: relative;
    }
</style>

<style lang="scss" scoped>
    .hosted-layers-wrap {
        flex: 1;

        > div {
            .slds-card {
                height: 100%;
                display: flex;
                flex-direction: column;

                .slds-card__body {
                    height: 100%;
                }

                .table-empty-state {
                    height: 100%;
                    color: #5876a3;

                    img {
                        width: 340px;
                    }

                    h4, p {
                        line-height: 1.35;
                    }
                }
            }
        }
    }

    .slds-table .ma-selected-row {
        background-color: #FAFFBD;
    }

    .slds-table .slds-spinner {
        display: none;
    }

    .slds-pill {
        background-color: #ecebea;
        border-radius: 1rem;
        font-size: 0.5rem;
        color: #3e3e3c;
        text-transform: uppercase;
        letter-spacing: 0.0625rem;
        min-height: 0;

        .slds-spinner {
            display: block;
        }

        .slds-pill__action {
            padding-left: calc(1.5rem + 2px);
        }
    }

    .slds-pill__action {
        border: none;
        padding-left: 0;
    }

    .ma-icon-warning {
        color: #c23934;
    }

    .slds-icon {
        display: flex;
        justify-content: center;
    }

    .slds-setup-assistant__item {
        border-bottom: none;
    }
    .datasetDesc:hover .slds-popover {
        display: block;
    }
    .slds-popover {
        display: none;
    }
    .descriptionHeader {
        padding: .25rem .5rem;
    }
</style>
